import React from 'react';
import moment from 'moment';
import { EnvelopeIcon, PaperClipIcon } from '@heroicons/react/24/outline';

const UnmatchedEmailsList = ({ emails, selectedId, onSelect }) => {
  const getStatusBadge = status => {
    const styles = {
      pending: 'bg-yellow-100 text-yellow-700',
      assigned: 'bg-green-100 text-green-700',
      ignored: 'bg-gray-100 text-gray-500',
    };
    const labels = {
      pending: 'Pendiente',
      assigned: 'Asignado',
      ignored: 'Ignorado',
    };
    return (
      <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${styles[status] || styles.pending}`}>
        {labels[status] || status}
      </span>
    );
  };

  return (
    <div className='divide-y divide-gray-200'>
      {emails.map(email => (
        <div
          key={email._id}
          onClick={() => onSelect(email)}
          className={`p-4 cursor-pointer transition-colors hover:bg-gray-50 ${
            selectedId === email._id ? 'bg-blue-50 border-l-4 border-blue-500' : ''
          }`}
        >
          <div className='flex items-start gap-3'>
            <div className='p-2 bg-gray-100 rounded-lg'>
              <EnvelopeIcon className='w-5 h-5 text-gray-500' />
            </div>

            <div className='flex-1 min-w-0'>
              <div className='flex items-center justify-between gap-2'>
                <div className='flex items-center gap-2 min-w-0'>
                  <span className='font-medium text-gray-800 truncate'>
                    {email.from_name || email.from_email}
                  </span>
                  {email.attachments?.length > 0 && (
                    <PaperClipIcon className='w-4 h-4 text-gray-400 flex-shrink-0' />
                  )}
                </div>
                <div className='flex items-center gap-2 flex-shrink-0'>
                  {getStatusBadge(email.status)}
                  <span className='text-xs text-gray-500'>
                    {moment(email.received_at).format('DD/MM HH:mm')}
                  </span>
                </div>
              </div>

              <p className='text-sm font-medium text-gray-700 truncate mt-1'>
                {email.subject || '(Sin asunto)'}
              </p>

              <p className='text-sm text-gray-500 truncate mt-0.5'>
                {email.body_text?.substring(0, 100) || '(Sin contenido)'}
              </p>

              {email.from_email && email.from_name && (
                <p className='text-xs text-gray-400 mt-1'>
                  {email.from_email}
                </p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UnmatchedEmailsList;
